"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mongoParser = void 0;
const parsimmon_1 = __importDefault(require("parsimmon"));
const common_1 = require("./common");
const operatorCondition = operator => value => ({
    __placeholder__: {
        [operator]: value,
    },
});
const regexCondition = regexString => value => ({
    __placeholder__: {
        $regex: regexString.replace('#VALUE#', value),
        $options: 'i',
    },
});
const numberTestCondition = () => value => ({
    $or: [
        {
            __placeholder__: {
                $regex: `.*${value}.*`,
                $options: 'i',
            },
        },
        {
            __placeholder__: value,
        },
    ],
});
const idRegex = /[('"]([0-9a-f]{24})['")]/;
const objectIdTestCondition = () => value => ({
    $or: [
        {
            __placeholder__: { $oid: value.match(idRegex)[1] },
        },
    ],
});
const testCondition = (operator, value) => () => ({
    __placeholder__: {
        [operator]: value,
    },
});
const multiTestCondition = condition => () => ({
    __placeholder__: condition,
});
const compoudCondition = conditionType => conditions => {
    if (conditions.length == 1)
        return conditions[0];
    return {
        [conditionType]: conditions,
    };
};
const negateCondition = condition => ({
    __placeholder__: {
        $not: condition.__placeholder__,
    },
});
const createParser = () => {
    const langDef = {
        string1: () => (0, common_1.token)(parsimmon_1.default.regexp(/"((?:\\.|.)*?)"/, 1))
            .map(common_1.interpretEscapes)
            .desc('string quoted'),
        string2: () => (0, common_1.token)(parsimmon_1.default.regexp(/'((?:\\.|.)*?)'/, 1))
            .map(common_1.interpretEscapes)
            .desc('string quoted'),
        number: () => (0, common_1.token)(parsimmon_1.default.regexp(/-?(0|[1-9][0-9]*)([.][0-9]+)?([eE][+-]?[0-9]+)?/))
            .map(Number)
            .desc('number'),
        objectid: () => (0, common_1.token)(parsimmon_1.default.regexp(/ObjectId\(['"]?[0-9a-f]{24}['"]?\)/)).desc('ObjectId'),
        noQuotedString: () => parsimmon_1.default.regexp(/[^\s^,^'^"]+/).desc('string unquoted'),
        value: r => parsimmon_1.default.alt(r.objectid, r.string1, r.string2, r.number, r.noQuotedString),
        valueTestObjectId: r => r.objectid.map(objectIdTestCondition()),
        valueTestNum: r => r.number.map(numberTestCondition()),
        valueTest: r => r.value.map(regexCondition('.*#VALUE#.*')),
        comma: () => (0, common_1.word)(','),
        not: () => (0, common_1.word)('NOT'),
        empty: () => (0, common_1.word)('EMPTY'),
        array: () => (0, common_1.word)('ARRAY'),
        notExists: r => r.not.then(r.exists).map(testCondition('$exists', false)),
        notEmptyArray: r => r.not
            .then(r.empty)
            .then(r.array)
            .map(multiTestCondition({ $exists: true, $type: 'array', $ne: [] })),
        emptyArray: r => r.empty.then(r.array).map(multiTestCondition({ $exists: true, $eq: [] })),
        exists: () => (0, common_1.word)('EXISTS').map(testCondition('$exists', true)),
        true: () => (0, common_1.word)('TRUE').map(testCondition('$eq', true)),
        false: () => (0, common_1.word)('FALSE').map(testCondition('$eq', false)),
        eq: r => (0, common_1.word)('=').then(r.value).map(operatorCondition('$eq')),
        ne: r => (0, common_1.word)('!=').then(r.value).map(operatorCondition('$ne')),
        ne2: r => (0, common_1.word)('<>').then(r.value).map(operatorCondition('$ne')),
        lt: r => (0, common_1.word)('<').then(r.value).map(operatorCondition('$lt')),
        gt: r => (0, common_1.word)('>').then(r.value).map(operatorCondition('$gt')),
        le: r => (0, common_1.word)('<=').then(r.value).map(operatorCondition('$lte')),
        ge: r => (0, common_1.word)('>=').then(r.value).map(operatorCondition('$gte')),
        startsWith: r => (0, common_1.word)('^').then(r.value).map(regexCondition('#VALUE#.*')),
        endsWith: r => (0, common_1.word)('$').then(r.value).map(regexCondition('.*#VALUE#')),
        contains: r => (0, common_1.word)('+').then(r.value).map(regexCondition('.*#VALUE#.*')),
        startsWithNot: r => (0, common_1.word)('!^').then(r.value).map(regexCondition('#VALUE#.*')).map(negateCondition),
        endsWithNot: r => (0, common_1.word)('!$').then(r.value).map(regexCondition('.*#VALUE#')).map(negateCondition),
        containsNot: r => (0, common_1.word)('~').then(r.value).map(regexCondition('.*#VALUE#.*')).map(negateCondition),
        element: r => parsimmon_1.default.alt(r.exists, r.notExists, r.true, r.false, r.eq, r.ne, r.ne2, r.lt, r.gt, r.le, r.ge, r.notEmptyArray, r.emptyArray, r.startsWith, r.endsWith, r.contains, r.startsWithNot, r.endsWithNot, r.containsNot, r.valueTestObjectId, r.valueTestNum, r.valueTest).trim(common_1.whitespace),
        factor: r => r.element.sepBy(common_1.whitespace).map(compoudCondition('$and')),
        list: r => r.factor.sepBy(r.comma).map(compoudCondition('$or')),
    };
    return parsimmon_1.default.createLanguage(langDef);
};
exports.mongoParser = createParser();
